import { FC } from 'react';
import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    List,
    Box,
} from '@mui/material';
import {
    ExpandLess,
    ExpandMore,
    Add as AddIcon,
    Visibility as VisibilityIcon,
} from '@mui/icons-material';

interface SubmenuItemProps {
    label: string;
    isActive: boolean;
    onClick: () => void;
    icon?: 'add' | 'view';
}

interface MenuItemWithSubmenuProps {
    label: string;
    icon: React.ReactNode;
    isOpen: boolean;
    onToggle: () => void;
    activeItem: string | null;
    onItemClick: (route: string) => void;
    submenuItems: Array<{
        label: string;
        route: string;
    }>;
}

const getSubmenuIcon = (iconType?: 'add' | 'view') => {
    switch (iconType) {
        case 'add':
            return <AddIcon fontSize="small" />;
        case 'view':
            return <VisibilityIcon fontSize="small" />;
        default:
            return null;
    }
};

const SubmenuItem: FC<SubmenuItemProps> = ({ label, isActive, onClick, icon }) => {
    return (
        <ListItemButton
            sx={{
                pl: 4,
                borderRadius: 1,
                mb: 0.5,
                backgroundColor: isActive ? 'primary.light' : 'transparent',
                '&:hover': {
                    backgroundColor: isActive ? 'primary.light' : 'action.hover',
                },
            }}
            onClick={onClick}
        >
            <ListItemIcon sx={{ minWidth: 36 }}>
                {getSubmenuIcon(icon)}
            </ListItemIcon>
            <ListItemText primary={label} />
        </ListItemButton>
    );
};

export const MenuItemWithSubmenu: FC<MenuItemWithSubmenuProps> = ({
    label,
    icon,
    isOpen,
    onToggle,
    activeItem,
    onItemClick,
    submenuItems,
}) => {
    return (
        <Box>
            <ListItemButton
                onClick={onToggle}
                sx={{
                    borderRadius: 1,
                    mb: 0.5,
                    '&:hover': {
                        backgroundColor: 'action.hover',
                    },
                }}
            >
                <ListItemIcon sx={{ color: 'primary.main', minWidth: 40 }}>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={label} />
                {isOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {submenuItems.map((item) => (
                        <SubmenuItem
                            key={item.route}
                            label={item.label}
                            isActive={activeItem === item.route}
                            onClick={() => onItemClick(item.route)}
                            icon={item.label.toLowerCase().includes('create') ? 'add' : 'view'}
                        />
                    ))}
                </List>
            </Collapse>
        </Box>
    );
};
